import { AnimatePresence } from 'framer-motion';
import { Fragment } from 'react/jsx-runtime';
import { getInteraction } from '@/features/interactions/lib/registry';
import { MotionFlex } from '@/ui';
import { usePageExperienceContext } from '../../contexts/PageExperienceContext';
import { useCustomizeMode } from '../CustomizeMode';

export const PlatformBarInteractions = () => {
  const { experience } = usePageExperienceContext();
  const { action } = useCustomizeMode();

  // Only the Send sidebar claims this cluster (it owns the same interaction).
  // Magic doesn't: it opens by default, so yielding would hide Send for good.
  return (
    <AnimatePresence initial={false}>
      {!action && (
        <MotionFlex
          align="center"
          animate={{ width: 'auto', opacity: 1 }}
          exit={{ width: 0, opacity: 0 }}
          gap="2"
          initial={{ width: 0, opacity: 0 }}
          key="interactions"
          overflow="hidden"
          transition={{ duration: 0.22, ease: [0.4, 0, 0.2, 1] }}
        >
          {experience.interactionApps.map((interaction) => {
            const mod = getInteraction(interaction.applicationName);

            if (!mod?.ToggleComponent) {
              return <Fragment key={interaction.id} />;
            }

            return (
              <mod.ToggleComponent config={interaction} key={interaction.id} />
            );
          })}
        </MotionFlex>
      )}
    </AnimatePresence>
  );
};
